<template>
    <div>
        <div class="card shadow">

            <!--cabezera-->
            <div class="card-header">

                <div class="d-flex">
                    <div class="flex-fill">
                        <DenounceNotificationSearch></DenounceNotificationSearch>
                    </div>

                    <div class="float-end">
                        <DenounceNotificationPagination></DenounceNotificationPagination>
                    </div>

                </div>

            </div>

            <!--cuerpo-->
            <div class="card-body">

                <DenounceNotificationTable></DenounceNotificationTable>

            </div>
        </div>
    </div>
</template>
<script>
import DenounceNotificationTable from '@/components/Denounce/DenounceMenu/DenounceNotification/Denounce-notification-table.vue';
import DenounceNotificationPagination from '@/components/Denounce/DenounceMenu/DenounceNotification/Denounce-notification-pagination.vue';
import DenounceNotificationSearch from '@/components/Denounce/DenounceMenu/DenounceNotification/Denounce-notification-search.vue'

export default {
    name: 'DenounceNotification',

    components:{
        DenounceNotificationTable,
        DenounceNotificationPagination,
        DenounceNotificationSearch
    }

}
</script>
<style></style>